module.exports = __webpack_public_path__ + "assets/img/reset-password-v2.d6925d62.svg";